export default "__VITE_ASSET__CtQSEWnb__"